import { TabRoute, EntityListContainer } from '@hevoio/hevo-ui-toolkit';
import React from 'react';
import { ActivationList } from './Activation/ActivationList';
import { TargetList } from './Target/TargetList';

const tabs: TabRoute<unknown>[] = [
  {
    label: 'Activations',
    route: 'activation',
    Component: ActivationList
  },
  {
    label: 'Targets',
    route: 'target',
    Component: TargetList
  }
];

export function ActivateListPage() {
  return (
    <EntityListContainer
      title='Activate'
      description='Synchronize data in your Warehouse with your Target applications'
      tabs={tabs}
      defaultTab='activation'
    />
  );
}
